// CardGroups.js
import React from "react";
// import { mathCalculators } from "../Id/MathCalculator/ConstantsMathCalculator";
import { womenCalculators } from "../Id/WomenCalculator/ConstantsWomenCalculator";
import { financialCalculators } from "../Id/FinancialCalculator/ConstantsFinancialCalculator";
import { humanCalculators } from "../Id/HumanCalculator/ConstantsHumanCalculator";
import { islamicCalculators } from "../Id/IslamicCalculator/ConstantsIslamicCalculator";
import { studyCalculators } from "../Id/StudyCalculator/ConstantsStudyCalculator";
import { physicsCalculators } from "../Id/PhysicsCalculator/ConstantsPhysicsCalculator";
import { healthCalculators } from "../Id/HealthCalculator/ConstantsHealthCalculator";
import { otherCalculators } from "../Id/OtherCalculator/ConstantsOtherCalculator";
import { chemistryCalculators } from "../Id/ChemistryCalculator/ConstantsChemistryCalculator";
import { foodCalculators } from "../Id/FoodCalculator/ConstantsFoodCalculator";
import SearchComponent from "../../Components/SearchComponent";
import { Icons } from "../Icons";

const cardData = [
  {
    cardNumber: 1,
    cardTitle: "Kalkulator Waktu dan Tanggal",
    cardIcon: <Icons.AccessTime />,
    cardItems: humanCalculators,
    calculatorUrl: "/id/date-time-calculators/",
  },
  {
    cardNumber: 2,
    cardTitle: "Kalkulator Kesehatan",
    cardIcon: <Icons.Favorite />,
    cardItems: healthCalculators,
    calculatorUrl: "/id/health-calculators/",
  },
  {
    cardNumber: 3,
    cardTitle: "Kalkulator Wanita",
    cardIcon: <Icons.Female />,
    cardItems: womenCalculators,
    calculatorUrl: "/id/women-calculators/",
  },
  // {
  //   cardNumber: 4,
  //   cardTitle: "Kalkulator Matematika",
  //   cardIcon: <Icons.Calculate />,
  //   cardItems: mathCalculators,
  //   calculatorUrl: "/id/math-calculators/",
  // },
  {
    cardNumber: 5,
    cardTitle: "Kalkulator Islam",
    cardIcon: <Icons.VolunteerActivism />,
    cardItems: islamicCalculators,
    calculatorUrl: "/id/zakat-calculators/",
  },
  {
    cardNumber: 6,
    cardTitle: "Kalkulator IPK Universitas",
    cardIcon: <Icons.School />,
    cardItems: studyCalculators,
    calculatorUrl: "/id/study-calculators/",
  },
  {
    cardNumber: 7,
    cardTitle: "Kalkulator Fisika",
    cardIcon: <Icons.Science />,
    cardItems: physicsCalculators,
    calculatorUrl: "/id/physics-calculators/",
  },
  {
    cardNumber: 8,
    cardTitle: "Kalkulator Keuangan",
    cardIcon: <Icons.AttachMoney />,
    cardItems: financialCalculators,
    calculatorUrl: "/id/financial-calculators/",
  },

  {
    cardNumber: 10,
    cardTitle: "Kalkulator Umum",
    cardIcon: <Icons.MoreHoriz />,
    cardItems: otherCalculators,
    calculatorUrl: "/id/other-calculators/",
  },
  {
    cardNumber: 11,
    cardTitle: "Kalkulator Kimia",
    cardIcon: <Icons.Biotech />,
    cardItems: chemistryCalculators,
    calculatorUrl: "/id/chemistry-calculators/",
  },
  {
    cardNumber: 12,
    cardTitle: "Kalkulator Makanan",
    cardIcon: <Icons.Food />,
    cardItems: foodCalculators,
    calculatorUrl: "/id/food-calculators/",
  },
];

function CardGroups() {
  return (
    <React.Fragment>
      <SearchComponent />
      <br />
      <div
        className="row row-cols-1 row-cols-md-4"
        style={{ position: "relative", zIndex: "1" }}
      >
        {cardData.map((card, index) => (
          <div className="col" xs key={index} style={{ paddingBottom: "10px" }}>
            <div className="card">
              <div className="card-body">
                <div className="p-1 bg-success text-white">
                  <a
                    href={card.calculatorUrl}
                    style={{
                      fontSize: "16px",
                      color: "white",
                      padding: "10px",
                      display: "block",
                    }}
                    aria-label={card.cardTitle}
                  >
                    <div className="card-title">
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        {card.cardIcon}
                      </div>
                      <h2
                        style={{
                          fontSize: "16px",
                          justifyContent: "center",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <span style={{ marginLeft: "10px" }}>
                          {card.cardTitle}
                        </span>
                      </h2>
                    </div>
                  </a>
                </div>
                <hr />
                <div className="card-text">
                  {card.cardItems.map(
                    (item, itemIndex) =>
                      item.showMain && (
                        <a
                          key={itemIndex}
                          href={item.link}
                          className="item-link"
                        >
                          <span style={{ fontSize: "14px" }}>{item.name}</span>{" "}
                          <br />
                        </a>
                      )
                  )}
                </div>
              </div>
              <div className="card-footer" style={{ textAlign: "center" }}>
                <div style={{ paddingBottom: "10px" }}>
                  <a
                    className="btn btn-outline-success"
                    style={{ width: "90%" }}
                    href={card.calculatorUrl}
                  >
                    Selengkapnya
                  </a>
                  <br />
                </div>
              </div>
            </div>
          </div>
        ))}
        <br />
      </div>
      <hr />
      <div className="p-3 mb-2 bg-success text-white">
        Jika Anda memiliki pertanyaan atau ingin tim kami menambahkan kalkulator lain, atau ingin melaporkan masalah pada kalkulator tertentu, harap beri tahu kami melalui email berikut: info@do-calculate.com
      </div>
    </React.Fragment>
  );
}

export default CardGroups;